import CtaName from '../interfaces/ctaName';

const buttonLabels: CtaName = {
  KEEP_BOX: 'KEEP BOX',
  CANCEL_BOX: 'CANCEL BOX',
  CANCEL: 'CANCEL',
  REACTIVATE: 'REACTIVATE',
  SKIP_MY_BOX: 'YES, SWAP FOR CREDIT',
  BACK_HOME: 'Back home',
  YES_LEARN_MORE: 'YES, LEARN MORE',
  LEARN_MORE: 'LEARN MORE',
  NO_THANKS: 'No Thanks',
  CONTINUE: 'CONTINUE',
  SWAP_FOR_CREDIT: 'YES, SWAP FOR CREDIT',
  CONTACT_US_TO_UNSWAP: 'CONTACT US TO UNSWAP',
  SEE_DETAILS: 'See Details',
  VISIT_FAQ: 'VISIT FAQ',
  SWAP_NOW: 'SWAP NOW',
};

export default buttonLabels;
